module.exports = __webpack_public_path__ + "img/FeaturedImages.6343de7b.png";